import React from "react";
import UpdateButton from "@components/FlowActionButtons/UpdateButton";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import type { Task } from "@services/vesselCall/types";
import { VESSEL_CALL_STATUSES } from "./utils";

interface UpdateVesselCallETAProps {
  vesselCallFlowData?: {
    vesselCallId: string;
    task: Task | null;
    status: string;
    companyId?: string;
  };
  showUpdateButton?: boolean;
  onUpdateEta?: () => void;
}

const LANG_BASE = "vessel-call.vessel-call-status-header";

const UpdateVesselCallETA: React.FC<UpdateVesselCallETAProps> = ({
  vesselCallFlowData,
  showUpdateButton,
  onUpdateEta,
}) => {
  const { user } = useAuthStore();

  if (!vesselCallFlowData) {
    return null;
  }

  const isMainShippingAgent = user?.companyId && user.companyId === vesselCallFlowData.companyId;
  const isActionAvailable =
    vesselCallFlowData.status === VESSEL_CALL_STATUSES.APPROVED &&
    !!showUpdateButton &&
    isMainShippingAgent;

  if (!isActionAvailable || !onUpdateEta) {
    return null;
  }

  return (
    <UpdateButton
      langBase={LANG_BASE}
      permission="canUpdateVesselCall"
      isActionAvailable={isActionAvailable}
      onUpdate={onUpdateEta}
      variant="outlined"
    />
  );
};

export default UpdateVesselCallETA;
